import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import UploadImage from '../assets/images/Frame 1618870273.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { fetchFoodCategories } from "../redux/slices/categoriesSlice";
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { useDispatch } from "react-redux";
import { AddCategories } from "../services/addCategoryServices";
import { FaTimesCircle } from "react-icons/fa";
import ButtonLoader from "../components/ButtonLoader";

export function AddFoodCategory() {
  const [open, setOpen] = useState(false);
  const [imageFile, setImageFile] = useState('')
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() =>{
    dispatch(fetchFoodCategories())
  }, [dispatch])

  const formik = useFormik({
    initialValues: {
      name: '',
      imagePath: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Name is required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);

      const res = await AddCategories(values);
      if(res.statusCode === 200){
        dispatch(fetchFoodCategories())
        toast.success(res?.message)
        formik.resetForm()
        setLoading(false)
        setOpen(false)
      } else if(res?.statusCode === 203){
        toast.error(res.message)
        setLoading(false)
      }else if(res?.statusCode === 404){
        toast.error(res.message)
        setLoading(false)
      }else if(res?.statusCode === 999){
        toast.error(res.message)
        setLoading(false)
      } else {
        console.error(res?.message)
      }
    },
  });
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        let newImageFiles = [imageFile];
        newImageFiles = base64String;
        setImageFile(newImageFiles); 

        let formImages = [formik.values.imagePath];
        formImages = base64String; 
        formik.setFieldValue("imagePath", formImages); 
      };
      reader.readAsDataURL(file);
    }
  };

  const deleteImage = () => {
    let newImageFiles = [imageFile];
    newImageFiles = null;
    setImageFile(newImageFiles);
  
    let formImages = [formik.values.imagePath];
    formImages = null;
    formik.setFieldValue("imagesPath", formImages);
  };

  return (
    <div>
        <button onClick={() => setOpen(true)} className="bg-primaryRed hover:bg-primaryRed/70 text-white px-4 py-3 rounded-lg text-sm outline-none focuse:outline-none border-none">
           <p className="text-xs sm:text-sm">Create New Menu</p>
      </button>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} size="md"
        slotProps={{
          root: {
            className: `
              backdrop-blur-[1px] 
              bg-orange/20 
              rounded-tl-2xl 
            `,
          },
        }}  
      >
        <ModalClose />
          <div className="flex items-center justify-between gap-4 px-5 pt-10">
            <h1 className="capitalize text-[24px] font-bold text-primaryRed">Create New Food Menu</h1>
          </div>
          <h2 className="mb-3 px-5 mt-2 text-sm text-[#0A0A0A]/80">
            Add a fresh Menu to expand your menu and give customers more tasty options!          
          </h2>

          <form onSubmit={formik.handleSubmit} className="mt-3 text-xs p-6">
              <label htmlFor="name" className="text-md text-sm">Menu Name</label>
              <div className="my-2">
                <input
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="border border-[#00000] border-opacity-30 text-black rounded-md px-4 w-full py-2 outline-none ring-0 focus:outline-0 "
                  placeholder="E.G Street Food, Dessert, Brevegaes"
                 />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-500">{formik.errors.name}</div>
                ) : null}
              </div>
            {/* <div>
              <label htmlFor="description">Description</label>
              <input 
                id="description"
                name="description"
                type="text"
                placeholder="Describe this category, e.g., 'Classic Nigerian street snacks and quick bites." 
                className="border border-[#00000] border-opacity-30 px-3 rounded-md w-full py-1.5 placeholder:text-gray-400 text-sm outline-none ring-0 focus:outline-0"
              />
            </div> */}
            <h2 className="text-sm mt-6 mb-2 text-md">Add Image</h2>
            <p className="text-xs">Upload a clear  500x500 pixels, for the best display.</p>
            <div className="grid place-items-center mt-8">
              {!imageFile ? ( 
                <>
                  <label className="cursor-pointer border-0 rounded-lg rounded-tr-2xl">
                  <img src={UploadImage} alt="img"/>
                    <input type="file"
                      id="imagePath"
                      name="imagePath"
                      accept="/*"
                      onChange={(event) => handleFileChange(event)}
                      className="hidden w-[50px] h-[30px] rounded-xl"
                    />
                    {formik.touched.imagePath && formik.errors.imagePath ? (
                      <div className="text-red-500 text-xs">{formik.errors.imagePath}</div>
                    ) : null}
                  </label>
                </>
                  ):(
                  <div className="relative h-full text-xs">
                    <img src={imageFile} alt="img" className="rounded-tr-[60px] rounded-md h-[250px]"/>
                    <button
                      className="absolute top-4 right-6 outline-0 duration-500 transition-all ease-in-out"
                      onClick={deleteImage}
                    >
                      <FaTimesCircle className="text-3xl font-bold text-primaryRed" />
                    </button>
                  </div>
                )}
              </div>
            <div className="flex items-center mt-8 gap-10 justify-between">
              <button
              onClick={() => setOpen(false)}
                className="text-primaryRed bg-white w-full px-4 py-2 rounded-md outline-none ring-0 border border-[#FFB0B0] text-md hover:outline-none capitalize mt-6 focus:outline-none focus:border-primaryRed hover:bg-[#FFB0B0]"
              >Cancel </button>
              <button
                type="submit"
                disabled={loading}
                className="bg-[#FF0000] hover:bg-primaryRed/80 text-white text-md w-full px-4 py-2 rounded-md outline-none ring-0 border border-primaryRed hover:text-white capitalize mt-6 focus:outline-none focus:border-primaryRed hover:border-PrimaryRed"
                >
                {loading ? <ButtonLoader />
                  : <span> Save</span>
                  } 
              </button>
            </div>
          </form>
      </Drawer>
    </div>
  );
}
